export class Plotvariable {

    public name:string
    public colors:Array<string>
    public variable:string
    public unit:string
    public invertedYAxis:boolean
    public logarithmeAxis:boolean 
    public forceDomain:boolean
    public minDomain:number
    public maxDomain:number
    public typeData:string
    public autoPlot:boolean      
    public variables:Array<string> | boolean
    public infosVariables:Array<string> | boolean
    

    constructor({name = '',colors =[] as Array<string>,variable = '', unit = '',invertedYAxis= false,logarithmeAxis= false,forceDomain= false,minDomain= 0,maxDomain= 0, typeData = 'number', autoPlot = false, variables=false as Array<string> | boolean,infosVariables=false as Array<string> | boolean } = {}) {
        this.name = name
        this.variable = variable
        this.unit = unit
        this.invertedYAxis = invertedYAxis
        this.logarithmeAxis = logarithmeAxis        
        this.forceDomain = forceDomain 
        this.minDomain = minDomain 
        this.maxDomain = maxDomain 
        this.typeData = typeData
        this.autoPlot = autoPlot        
        this.variables = variables
        this.infosVariables = infosVariables
        this.colors = colors
    }
}